import { FORMAT_DATE_DAY } from '@/utils'

export default FORMAT_DATE_DAY
